import React from 'react';
import SettingsTab from '../../components/admin/SettingsTab';

const SystemPage = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">System</h1>
        <p className="text-sm text-gray-600">Systemeinstellungen und Konfiguration</p>
      </div>
      <SettingsTab />
    </div>
  );
};

export default SystemPage;
